// hooks/useDashboardSocket.ts
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { WSInstance } from './web-socket-service';

export const useNotificationSocket = (onNotification: (data: any) => void) => {
    const token = useSelector((state: any) => state.app.session?.token);
    const userId = useSelector((state: any) => state.user?.userId);
    useEffect(() => {
        if (!token || !userId) return;

        WSInstance.connect(token);
        console.warn(userId, 'userId in use notification Socket');
        WSInstance.on(`notification/${userId}/count`, onNotification);

        WSInstance.socket?.io.on('error', (error: any) => {
            console.warn('Socket error:', error);
        });

        // eslint-disable-next-line consistent-return
        return () => {
            console.warn('unmounting notification socket');
            WSInstance.off(`notification/${userId}/count`, onNotification);
        };
    }, [userId, token, onNotification]);
};
